import { cn } from '@/lib/utils';
import SimpleTooltip from '../tooltip/SimpleTooltip';
import { ComponentProps } from 'react';

interface Props extends ComponentProps<typeof SimpleTooltip> {
  className?: string;
}

export const IconButton = ({
  children,
  className,
  containerClassName,
  tooltipContent,
}: Props) => {
  if (tooltipContent) {
    return (
      <SimpleTooltip
        tooltipContent={tooltipContent}
        containerClassName={containerClassName}
      >
        <div
          className={cn(
            'cursor-pointer hover:bg-grey-5 rounded-full p-2',
            className,
          )}
        >
          {children}
        </div>
      </SimpleTooltip>
    );
  }

  return <div className={cn('cursor-pointer', className)}>{children}</div>;
};
